import React from "react";
import { Link } from "react-router-dom";
import BannerImage from "../../../assets/banner-photo.png";
import RedLineImg from "../../../assets/svg/red-line.svg";
import BannerPhotoMobile from "../../../assets/banner-photo-mobile.png";
import RightArrow from "../../../assets/svg/right-arrow-white.svg";
import { useSelector } from "react-redux";

function MissionBanner() {
  const { data: homeContet } = useSelector(
    (x) => x?.home?.homePageContentResponse,
  );
  const isUserLoggedIn = JSON.parse(sessionStorage?.getItem("isLoggedIn"));
  console.log(homeContet);

  return (
    <section
      className="mission-banner"
      style={{ height: isUserLoggedIn ? "700px" : "" }}
    >
      <div className="image-line">
        <div
          className="circle banner-img-1"
          data-sal="slide-down"
          data-sal-duration="900"
        >
          <img
            src={
              homeContet?.bannerImageOne
                ? process.env.REACT_APP_API_IMAGE_URL +
                  homeContet.bannerImageOne
                : BannerImage
            }
            alt="Child_and_adult"
          />
        </div>
        <div className="circle red-line">
          <img src={RedLineImg} alt="line" />
        </div>
        <div className="circle banner-photo-mobile">
          <img src={BannerPhotoMobile} alt="line" />
        </div>
      </div>

      <div className="mission-text">
        <h1>{homeContet?.bannerTitle}</h1>

        <p
          dangerouslySetInnerHTML={{ __html: homeContet?.bannerDescription }}
        ></p>
        {!isUserLoggedIn && (
          <div className="div-center">
            <Link to={homeContet?.bannerButtonUrl} className="cta-button">
              {homeContet?.bannerButtonLabel}
              <img
                src={RightArrow}
                alt="arrow_right"
                className="csc-arrow-icon"
              />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}

export default MissionBanner;
